import { OnInit, Component, Input, ViewChild } from '@angular/core';
import { Rsvp } from '../models/rsvp';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { RsvpStore } from '../service/rsvp.store';
import { OnyxEvent } from '../models/event';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'pioneer-rsvp-list',
  templateUrl: './rsvp-list.component.html'
})
export class RsvpListComponent implements OnInit {
  rsvpToRemove: Rsvp;

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(private rsvpStore: RsvpStore) {
  }

  ngOnInit() {
    if (!this.onyxEvent) {
      throw new Error('The "event" attribute must be specified to use the "pioneer-rsvp-list" component');
    }
  }

  get rsvps(): Observable<List<Rsvp>> {
    return this.rsvpStore.rsvps;
  }

  get totalNights(): Observable<number> {
    return this.rsvpStore.totalNights;
  }

  get totalRevenue(): Observable<number> {
    return this.rsvpStore.totalRevenue;
  }

  get totalCommission(): Observable<number> {
    return this.rsvpStore.totalCommission;
  }

  get isRsvpListEmpty(): Observable<boolean> {
    return this.rsvps.map(rsvpList => rsvpList.size === 0);
  }

  confirmBeforeDelete(rsvp: Rsvp) {
    this.rsvpToRemove = rsvp;
    this.confirmationModal.open();
  }

  confirmHandler(deleteConfirmed: boolean) {
    if (deleteConfirmed) {
      this.deleteRsvp(this.rsvpToRemove);
    }

    this.rsvpToRemove = null;
  }

  deleteRsvp(rsvp: Rsvp): Observable<boolean> {
    const obs = this.rsvpStore.deleteRsvp(rsvp);
    obs.subscribe();
    return obs;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp-list/rsvp-list.component.ts